import {
    eCommerceGTMSelection,
    actionTypes,
} from '~shared/utils/google-tag-manager';

import {
    ACTION_STRING_CLEAR_SELECTIONS,
    ACTION_STRING_REMOVE_SELECTION,
} from '~Betslip/actions/userSelectionsActions';

export const betslipGtmMiddleware = (store) => (next) => (action) => {
    let selectionId = null;
    switch (action.type) {
        case ACTION_STRING_CLEAR_SELECTIONS:
            selectionId = action.payload?.selectionId;
            break;
        case ACTION_STRING_REMOVE_SELECTION:
            selectionId = action.payload;
            break;
        default:
            break;
    }

    if (selectionId) {
        const { selectionDetails } = store.getState().betslip;
        eCommerceGTMSelection(
            selectionDetails[selectionId],
            selectionId,
            actionTypes[1],
            'removeFromCart'
        );
    }

    return next(action);
};
